module.exports = __webpack_public_path__ + "img/angle-double-right-solid.67a570c7.svg";